import React, {useEffect, useState} from "react";
import PageContainer from "../../layouts/PageContainer";
import {helpers} from '../../helper/helper';
import {useCallback} from "react";
import UsersList from "./UsersList";
import Loader from "../../layouts/Loader";
import {useSnackbar} from "notistack";
import Swal from "sweetalert2";

const Users = () => {
    const {enqueueSnackbar} = useSnackbar();
    const [skip, setSkip] = useState(1);
    const [loading, setLoading] = React.useState(false);
    const [limit, setLimit] = useState(10);
    const [userList, setUserList] = useState();
    const [open, setOpen] = React.useState(false);
    const [openBlock, setOpenBlock] = React.useState(false);
    const [filterText, setFilterText] = useState({
        query: "",
        queryType: { gender: "", subscribe: "" },
    });
    const handleClose = () => {
        setOpen(false);
    };
    const handleCloseBlock = () => {
        setOpenBlock(false);
    };

    const UsersData = useCallback(async (skip, limit, search, gender, kycStatus) => {
        setLoading(true);
        const url = `users?skip=${skip}&limit=${limit}&search=${search}&gender=${gender}&kycStatus=${kycStatus === "true" ? "completed" : kycStatus === "false" ? "rejected" : ""}`;
        const result = await helpers.apiCall('GET', url);
        setUserList(result.data);
        setLoading(false);
    }, [setUserList]);

    useEffect(() => {
        UsersData(skip, limit, filterText?.query, filterText?.queryType?.gender, filterText?.queryType?.subscribe);
        setOpen(false);
        setOpenBlock(false)
    }, [UsersData, skip, limit, filterText]);

    // useEffect(() => {
    //     UsersData(skip, limit, filterText?.query, filterText?.queryType?.gender, filterText?.queryType?.subscribe);
    // }, [skip, limit, filterText])
    
    // const fetchDataOfFilter = () => {
    //     console.log('filterText inside the fetchData', filterText)
    //     UsersData(skip, limit, filterText?.query, filterText?.queryType?.gender, filterText?.queryType?.subscribe);
    // }

    const deleteGifts = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f50057",
            cancelButtonColor: "#263273",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.value) {
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
                const url = `users/${id}`;
                const result = await helpers.apiCall("DELETE", url);
                if (result.status === 200) {

                    UsersData(skip, limit, filterText?.query, filterText?.queryType?.gender, filterText?.queryType?.subscribe);
                    enqueueSnackbar("User Deleted successfully", {
                        variant: 'success',
                        autoHideDuration: 3000,
                    });
                    handleClose()
                } else {
                    enqueueSnackbar(result.data ? result.data.message : result.message, {
                        variant: 'error',
                        autoHideDuration: 3000,
                    });
                }
            }
        });

    };
    const BlockUser = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't to Block /Unblock ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f50057",
            cancelButtonColor: "#263273",
            confirmButtonText: "Yes",
        }).then(async (result) => {
            if (result.value) {
                Swal.fire("", "", "success");
                const url = `users/block/${id}`;
                const result = await helpers.apiCall("PUT", url);
                if (result.status === 200) {
                    handleCloseBlock();
                    UsersData(skip, limit, filterText?.query, filterText?.queryType?.gender, filterText?.queryType?.subscribe);
                    enqueueSnackbar("User BLocked successfully", {
                        variant: 'success',
                        autoHideDuration: 3000,
                    });
                } else {
                    enqueueSnackbar(result.data ? result.data.message : result.message, {
                        variant: 'error',
                        autoHideDuration: 3000,
                    });
                }
            }
        });

    };
    return (
        <PageContainer pageheading="USER LIST">
            {!userList || loading ? <div style={{ display: "flex", width: "100%", height: "60vh", justifyContent: "center", alignItems: "center" }}>
                <div className="spinner-border" style={{ color: "#F85476" }} role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div> :
                <UsersList userList={userList} deleteGifts={deleteGifts} BlockUser={BlockUser} setOpen={setOpen}
                           setOpenBlock={setOpenBlock}
                           open={open}
                           handleClose={handleClose}
                           openBlock={openBlock}
                           filterText={filterText}
                           setFilterText={setFilterText}
                           skip={skip}
                           setSkip={setSkip}
                           limit={limit}
                           setLimit={setLimit}
                        //    fetchDataOfFilter={fetchDataOfFilter}
                           handleCloseBlock={handleCloseBlock}/>
            }
        </PageContainer>
    )
};
export default Users;